import { render } from "./DomiciliationView.vue?vue&type=template&id=2ebd8f56"
import script from "./DomiciliationView.vue?vue&type=script&lang=js"
export * from "./DomiciliationView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/declic-center-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__